import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type NonNullableKeys<T> = {
  [K in keyof T]: NonNullable<T[K]>;
};

type AuthRole = "user" | "admin";

export interface AuthState {
  role: AuthRole | undefined;
  email: string | undefined;
  name?: string | undefined;
}

const initialState: AuthState = {
  role: undefined,
  email: undefined,
  name: undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthData(state, action: PayloadAction<NonNullableKeys<AuthState>>) {
      const { role, name, email } = action.payload;
      state.role = role;
      state.name = name;
      state.email = email;
    },
    clearAuthData(state) {
      state.role = undefined;
      state.email = undefined;
      state.name = undefined;
    },
  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;

export default authSlice.reducer;
